import { render } from "./Snak.vue?vue&type=template&id=50796231"
import script from "./Snak.vue?vue&type=script&lang=js"
export * from "./Snak.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__